/**
 * Forces every hyperlink inside the Konfigr diagram/parts-list widget to
 * open in a new tab, per request - scoped to just that app section on
 * the "konfig" alternate product template (product.konfig.json), not
 * sitewide. We don't control Konfigr's own markup (it's a third-party
 * Vue app - data-v-app - rendering its own <a> tags for things like the
 * product title link, "View" links, etc.), so this can only be done by
 * patching anchors after the fact rather than editing them at the
 * source.
 *
 * Polling, not a MutationObserver, for the same reason as
 * judgeme-tab-dismiss.js: Konfigr mounts its DOM on its own async
 * schedule and a MutationObserver on document.body reliably failed to
 * catch an equivalent Vue-driven mount in that other case. Polling
 * doesn't care how/when the anchors show up and self-heals if Konfigr
 * ever re-renders them later (e.g. switching variants/options within
 * the widget).
 */
(function () {
  var SECTION_SELECTOR = '[id^="shopify-section-"][id$="__1787075892632584d8"]';

  function patchLinks() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    var links = section.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.target !== '_blank') link.target = '_blank';
      // noopener/noreferrer: standard safety pairing for target="_blank"
      // links to a same- or unknown-origin destination (Konfigr's own
      // "View product" style links point back to this same store, but
      // there's no reason not to apply the same safe default throughout).
      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      link.setAttribute('rel', rel.join(' '));
    }
  }

  setInterval(patchLinks, 500);
})();
